<template>
  <div class="productlist-dialog-wrap" v-if="isUplodFilesDialogOpen">
    <div class="productlist-dialog">
      <!-- head -->
      <div class="pa-5">
        <h3>批次匯入CSV</h3>
      </div>
      <!-- step -->
      <div class="py-5 pl-5 pr-80px">
        <Stepper :currentStep="currentStep"></Stepper>
      </div>
      <!-- description -->
      <div class="px-5 pt-5">
        <h5 v-if="currentStep == 1">
          針對單筆產品多語言內容批次匯入，請參考範本檔案
          <!--<a href="#" class="ink-01-emphasis&#45;&#45;text text-decoration-none mr-1"-->
            <!--&gt;下載CSV範本</a-->
          <!--&gt;-->
          <a href="/productImportExample.xlsx"
             class="ink-01-emphasis--text text-decoration-none"
             target="_blank"
            >下載XLS範本</a>
        </h5>
        <h5 v-if="currentStep == 2">
          上傳前請先檢查 ZIP內各檔案名稱 是否與CSV或XLS內所對應名稱一致
        </h5>
      </div>
      <!-- body -->
      <div class="pa-5">
        <div
          class="productlist-dialog__upload-area"
        >
          <Dialog1
            v-if="currentStatus == 1"
            :currentStep.sync="currentStep"
            :currentStatus.sync="currentStatus"
            :file.sync="file"
          ></Dialog1>
          <!--<Dialog2-->
            <!--v-if="currentStatus == 2"-->
            <!--:currentStep.sync="currentStep"-->
            <!--:currentStatus.sync="currentStatus"-->
          <!--&gt;</Dialog2>-->
          <Dialog3
            v-if="currentStatus == 2"
            :currentStep.sync="currentStep"
            :currentStatus.sync="currentStatus"
            :file.sync="file"
          ></Dialog3>
          <Dialog4
            v-if="currentStatus == 3"
            :currentStep.sync="currentStep"
            :currentStatus.sync="currentStatus"
            :zip.sync="zip"
          ></Dialog4>
          <!--<Dialog5-->
            <!--v-if="currentStatus == 5"-->
            <!--:currentStep.sync="currentStep"-->
            <!--:currentStatus.sync="currentStatus"-->
          <!--&gt;</Dialog5>-->
          <Dialog6
            v-if="currentStatus == 4"
            :currentStep.sync="currentStep"
            :currentStatus.sync="currentStatus"
            :zip.sync="zip"
          ></Dialog6>
        </div>
      </div>
      <!-- foot -->
      <div class="pa-5 text-right">
        <button class="btn w-100px mr-10px" @click="cancelHandler">取消</button>
        <button
          class="btn w-100px btn-primary"
          :class="{ disabled: currentStatus == 1}"
          v-if="currentStatus == 1 || currentStatus == 2"
          @click="nextStep"
        >
          下一步
        </button>
        <button
          class="btn w-100px btn-primary"
          :class="{ disabled: currentStatus == 3}"
          v-if="currentStatus == 3 || currentStatus == 4"
          @click="importFiles"
        >
          匯入
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// Zeplin: https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f214b051a66767ffd9b99d1
import Stepper from '@/views/C-3__Products/c/Stepper.vue';

import Dialog1 from '@/views/C-3__Products/c/C-3e-1a__ProductList_Dialog-with-DropZone_1.vue';
import Dialog3 from '@/views/C-3__Products/c/C-3e-1c__ProductList_Dialog-with-DropZone_3-fileAttached.vue';
import Dialog4 from '@/views/C-3__Products/c/C-3e-1d__ProductList_Dialog-with-DropZone_4-uploadZIP.vue';
import Dialog6 from '@/views/C-3__Products/c/C-3e-1f__ProductList_Dialog-with-DropZone_6-fileAttached.vue';

export default {
  components: {
    Stepper,
    Dialog1,
    Dialog3,
    Dialog4,
    Dialog6,
  },
  props: {
    isUplodFilesDialogOpen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentStep: 1,
    currentStatus: 1,
    file: null,
    zip: null,
  }),
  methods: {
    ...mapActions(['import']),
    ...mapActions('notifications', ['success', 'error']),
    ...mapActions('product', {
      getProduct: 'find',
    }),
    cancelHandler() {
      this.file = null;
      this.zip = null;
      this.currentStep = 1;
      this.currentStatus = 1;
      this.$emit('update:isUplodFilesDialogOpen', false);
    },
    nextStep() {
      this.currentStep = 2;
      this.currentStatus = 3;
    },
    importFiles() {
      if (this.currentStatus !== 4) {
        return;
      }
      const formData = new FormData();
      formData.append('file', this.file, this.file.name);
      formData.append('zip', this.zip, this.zip.name);
      this.import({
        url: '/import/product',
        data: formData,
      }).then(() => {
        this.success('匯入成功');
        this.getProduct();
      });
      this.cancelHandler();
    },
  },
};
</script>

<style lang="scss">
.productlist-dialog-wrap {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(133, 133, 133, 0.5);
  z-index: 100;
}

.productlist-dialog {
  width: 720px;
  margin: 0 auto;
  margin-top: 136px;
  background-color: #fff;
  border-radius: 4px;

  &__upload-area {
    height: 216px;
    border: solid 1px #848fa0;
    border-style: dashed;
    border-radius: 4px;

    &.active {
      border: solid 1px #194cc3;
      border-style: dashed;
      border-radius: 4px;
      background-color: #e8efff;
    }
  }
}
</style>
